import { logger } from 'src/commons/utils/logger';
import { CTCIPublisher } from 'src/commons/utils/metrics';

const MEASURE_KEY = 'aacchrome-nav-load-duration';
const NAV_START_MARK_NAME = 'aacchrome-nav-start';
const DURATION_FROM_PAGE_LOAD = 'durationFromPageLoad';
const DURATION_FROM_NAV_START = 'durationFromNavStart';
const DURATION_LOGGED_METRIC_FAILURE = 'navDurationFailure';

const publishNavLoadDuration = () => {
  try {
    // if there is no start time, measure returns the duration from page load
    const measurement = performance.measure(MEASURE_KEY, NAV_START_MARK_NAME);
    const metric =
      measurement.startTime === 0
        ? DURATION_FROM_PAGE_LOAD
        : DURATION_FROM_NAV_START;
    CTCIPublisher.publishTimerMonitor(metric, measurement.duration);
    CTCIPublisher.publishCounterMonitor(DURATION_LOGGED_METRIC_FAILURE, 0);
    performance.clearMeasures(MEASURE_KEY);
  } catch (e: any) {
    logger.error(`Failed to measure nav load: ${e.message}`);
    CTCIPublisher.publishCounterMonitor(DURATION_LOGGED_METRIC_FAILURE, 1);
  } finally {
    performance.clearMarks(NAV_START_MARK_NAME);
  }
};

export default publishNavLoadDuration;
